<script>
    import { createEventDispatcher } from "svelte";
    import { Icon, DocumentPlus, DocumentText, Trash, AdjustmentsHorizontal,
       QueueList, Eye, EyeSlash, EllipsisVertical } from "svelte-hero-icons";
    import {mapDatasetList} from "../../utils/mapDataset";
    import { slide } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import SearchBar from './SearchBar.svelte';

    // export let toggleLayDetail;
    export let activeTab = "Available Datasets"; // Track the active tab
    let activeClasses="text-blue-600 bg-gray-200 active dark:bg-gray-800 dark:text-blue-500 ";
    let inactiveClasses='hover:text-gray-600 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-gray-300';
    
    let layersState = mapDatasetList.map(config => ({
        ...config,
        layer: null, // Layer instance
        added: false, // Whether the layer is added to the map
        active:false,
        opacity: 1, // Add default opacity
        legendData:null,
        legendVisible:false,
        isVisible:true,
        isFiltered:true,
    }));

    let selectedDatasets=[];

    // let layerList=['Landcover in HKH','Forest Fire','Earthquake','Glacier in Bhutan', 'Galcial lakes'];
    const dispatch = createEventDispatcher();
    // Emit toggle event with the layer title
    function handleToggle(layer) {
      dispatch("toggle", layer);
    }

    function selTab_RemoveLayer(layer){
      layer.added=false;
      layer.active=false;
      const updatedLayer = layersState.find(l => l.id === layer.id);
      const existingIndex = selectedDatasets.findIndex(d => d.id === updatedLayer.id);
      if (existingIndex !== -1) {
        // Remove if exists
        selectedDatasets.splice(existingIndex, 1);
      }
      selectedDatasets=[...selectedDatasets];
      dispatch("addToMap", updatedLayer);
    }

    function addLayerToMap(layer){  
      // layer.active=!layer.active; 
      // layersState = layersState.map(l => {
      //   if (l === layer) {
      //     return { ...l, 
      //       added:!l.added,
      //       active:!l.active
      //     }; // Create a new object reference
      //   }
      //   return l;
      // });
      layer.added=!layer.added;
      layer.active=!layer.active;
      layersState = [...layersState];
      const updatedLayer = layersState.find(l => l.id === layer.id);
     
      // Check if layer exists in selectedDatasets
      const existingIndex = selectedDatasets.findIndex(d => d.id === updatedLayer.id);
      if (existingIndex !== -1) {
        // Remove if exists
        selectedDatasets.splice(existingIndex, 1);
      } else {
        // Add if doesn't exist
        selectedDatasets.unshift(updatedLayer);
      }
      
      dispatch("addToMap", updatedLayer);
    }
    const setActiveTab = (tab) => {
        activeTab = tab;
    };

    let showOpacitySlider = null; // To track which layer's opacity slider is visible
    
    function handleOpacityChange(layer, event) {
        const opacity = event.target.value / 100;
        
        // Update the opacity
        layer.opacity = opacity;
        
        // Trigger reactivity by reassigning the arrays
        layersState = [...layersState];
        selectedDatasets = [...selectedDatasets];
        
        dispatch("opacityChange", { layer, opacity });
    }

    function handleClickOutside(event) {
        const opacityContainer = event.target.closest('.opacity-container');
        const opacityButton = event.target.closest('.opacity-button');
        
        if (!opacityContainer && !opacityButton && showOpacitySlider !== null) {
            showOpacitySlider = null;
        }
    }

    // let showLegend = null; // To track which layer's legend is visible
    // let legendData = {}; // Store legend data for layers

    async function fetchLegend(layer) {
        try {
            let legendResponse;
            
            if (layer.mapServer === 'arcgis') {
                // ArcGIS REST API legend request
                const legendUrl = `${layer.mapServiceURL}/legend?f=json`;
                const response = await fetch(legendUrl);
                const data = await response.json();
                
                // Process ArcGIS legend format
                legendResponse = data.layers?.find(l => l.layerId === layer.layerIndex)?.legend || [];
                
                // Transform ArcGIS format to common format
                return legendResponse.map(item => ({
                    label: item.label,
                    imageData: `data:image/png;base64,${item.imageData}`,
                    values: item.values
                }));

            } else if (layer.mapServer === 'geoserver') {
                // GeoServer WMS GetLegendGraphic request
                const legendUrl = `${layer.mapServiceURL}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=${layer.layerIndex}&STYLE=${layer.style || ''}`;
                // const response = await fetch(legendUrl);
                // const data = await response.json();
                
                // Process GeoServer colormap legend format
                // const rules = data.Legend?.[0]?.rules?.[0]?.symbolizers?.[0]?.Raster?.colormap?.entries || [];
                
                // // Transform colormap entries to common format
                // return rules.map(entry => ({
                //     label: entry.label.trim(),
                //     color: entry.color,
                //     opacity: entry.opacity || "1.0",
                //     value: entry.quantity
                // }));

                return [{
                  label:'',
                  imageUrl:legendUrl,
                }]
            }
            
            return null;
        } catch (error) {
            console.error('Error fetching legend:', error);
            return null;
        }
    }

    async function toggleLegend(layer) {
        const layerIndex = layersState.findIndex(l => l.id === layer.id);
        if (layer.legendVisible) {
            layersState[layerIndex] = { ...layer, legendVisible: false };
        } else {
            if (!layer.legendData) {
                const legendData = await fetchLegend(layer);
                layersState[layerIndex] = { ...layer, legendData, legendVisible: true };
            } else {
                layersState[layerIndex] = { ...layer, legendVisible: true };
            }
        }
        layersState = [...layersState]; // Trigger reactivity
        selectedDatasets = selectedDatasets.map(d => 
            d.id === layer.id ? layersState[layerIndex] : d
        );
    }

    function toggleVisibility(layer) {
      layer.isVisible=!layer.isVisible;
      const updatedLayer = layersState.find(l => l.id === layer.id);
      const existingIndex = selectedDatasets.findIndex(d => d.id === updatedLayer.id);
      if (existingIndex !== -1) {
        // Remove if exists
        selectedDatasets[existingIndex].isVisible=layer.isVisible;
      }
      selectedDatasets=[...selectedDatasets];
      
      layer.layer.setVisible(layer.isVisible);
    }

    // Add these variables to track drag state
    let draggedItem = null;
    let draggedOverItem = null;

    // Add this function to handle drag and drop
    function handleDragDrop(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        
        const items = [...selectedDatasets];
        const [reorderedItem] = items.splice(fromIndex, 1);
        items.splice(toIndex, 0, reorderedItem);
        
        selectedDatasets = items;
        const totalLayers = selectedDatasets.length;
        const reversedFromIndex = totalLayers - fromIndex;
        const reversedToIndex = totalLayers - toIndex;
        
        dispatch("reorderLayers", { 
            layer: reorderedItem, 
            fromIndex: reversedFromIndex, 
            toIndex: reversedToIndex 
        });
      }

    
    function applyFilters(e) {
      let selectedKeywords = e.detail;
      layersState = layersState.map(layer => ({
        ...layer,
        isFiltered: selectedKeywords.length === 0 || selectedKeywords.some(keyword =>
          layer.title.toLowerCase().includes(keyword.toLowerCase())
        )
      }));
      layersState = [...layersState];
      selectedDatasets = [...selectedDatasets]; 

    }


</script>

<svelte:window on:click={handleClickOutside} />

<style>
    .drag-over {
        border: 2px dashed #4a90e2;
        transform: translateY(10px) scale(0.95);
    }
</style>

<SearchBar
on:applyFilters={(e) => applyFilters(e)}
on:searchDatasets={(e) => applyFilters(e)}
/>

  <div class="mx-4 my-0 shadow border-b border-gray-300 dark:border-gray-700">
    <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400" id="tabs-example" role="tablist">
        <li class="me-2" role="presentation">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
            class={`inline-block p-4 rounded-t-lg border-b-2 border-transparent  cursor-pointer ${
                activeTab === "Available Datasets"
                  ? activeClasses
                  : inactiveClasses
              }`}
                type="button"
                role="tab"
                aria-controls="available-dataset"
                aria-selected="false"
                tabindex="0"
                on:click={(e) => {
                    e.preventDefault();
                    setActiveTab("Available Datasets");
                  }}
            >
                Available Datasets
              </div>
        </li>
        <li class="me-2" role="presentation">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
            class={`inline-block p-4 rounded-t-lg border-b-2 border-transparent  cursor-pointer ${
                activeTab === "Selected Datasets"
                  ? activeClasses
                  : inactiveClasses
              }`}
                type="button"
                role="tab"
                aria-controls="selected-dataset"
                aria-selected="false"
                tabindex="0"
                on:click={(e) => {
                    e.preventDefault();
                    setActiveTab("Selected Datasets");
                  }}
            >
                Selected Datasets
                </div>
        </li>
        
    </ul>
</div>


  <!-- Tab Content -->
  <div class="m-4 mt-0 bg-gray-200 p-4 shadow overflow-auto" style="height: calc(100% - 150px)">
    {#if activeTab === "Available Datasets"}
      <div id="available-dataset" class="text-gray-700">
        {#each layersState as lay}
          {#if lay.isFiltered}
            <div class="flex text-sm border border-gray-300 bg-gray-50 p-3 mb-2">
              <div class="flex-1">
              
              {lay.title}<br/>
              <!-- <span class="text-xs text-gray-500">Loren epsum ala carta</span> -->
            </div>
            <div class="inline-flex rounded-md shadow-sm" role="group">
              <button class="p-1 border border-gray-200 
                {lay.active ? 'bg-blue-400' : ''}" 
                on:click={() => addLayerToMap(lay)}>
                <Icon src={DocumentPlus} size="18" 
                class={ lay.active ? 'text-gray-50' : 'text-gray-500'}
                />
              </button>
              
              <button class="btnLayDetail p-1 border border-gray-200"
                on:click={() => handleToggle(lay)}>
                <Icon src={DocumentText} size="18" />
              </button>
            </div>
          </div>
          {/if}

        {/each}
        
      </div>
    {:else if activeTab === "Selected Datasets"}
      <div id="selected-dataset" class="text-gray-700">
        {#each selectedDatasets as slay, index}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="flex flex-col mb-2">
          <div class="flex flex-col text-sm border border-gray-300 bg-gray-50 p-3 pl-2 transition-all duration-300"
                draggable="true"
                on:dragstart={() => draggedItem = index}
                on:dragenter={() => draggedOverItem = index}
                on:dragend={() => {
                    if (draggedItem !== null && draggedOverItem !== null) {
                        handleDragDrop(draggedItem, draggedOverItem);
                    }
                    draggedItem = null;
                    draggedOverItem = null;
                }}
                class:drag-over={draggedOverItem === index && draggedItem !== index}>
              <!-- Title and buttons row -->
              <div class="flex items-center justify-between w-full">
                  <div class="flex-1">
                      <div class="flex gap-0">
                          <Icon 
                          class="hover:text-blue-600 cursor-move"
                          src={EllipsisVertical} size="18" />
                          <span>{slay.title}</span>
                      </div>
                  </div>
                  <div class="inline-flex rounded-md shadow-sm" role="group">
                      <button class="p-1 border border-gray-200"
                          alt="Toggle Layer's Visibility" 
                          on:click={() => toggleVisibility(slay)}>
                          <Icon src={slay.isVisible ? Eye : EyeSlash} size="18" />
                      </button>
                      <button class="p-1 border border-gray-200 
                        {slay.legendVisible?'bg-blue-400':''}" 
                          alt="Toggle Legend" 
                          on:click={() => toggleLegend(slay)}>
                          <Icon src={QueueList} size="18" 
                          class={slay.legendVisible?'text-gray-50':'text-gray-500'}
                          />
                      </button>
                      <button class=" p-1 border border-gray-200 opacity-button" 
                          alt="Adjust Opacity" 
                          on:click={() => showOpacitySlider = showOpacitySlider === slay.id ? null : slay.id}>
                          <Icon src={AdjustmentsHorizontal} size="18" />
                      </button>
                      
                      <button class="btnLayDetail p-1 border border-gray-200" 
                          on:click={() => handleToggle(slay)}>
                          <Icon src={DocumentText} size="18" />
                      </button>
                      <button class="p-1 border border-gray-200" 
                          on:click={() => selTab_RemoveLayer(slay)}>
                          <Icon src={Trash} size="18" 
                          class='text-red-500'
                          />
                      </button>
                  </div>
              </div>

              
            </div>
            <!-- Opacity slider -->
            {#if showOpacitySlider === slay.id}
            <div class="absolute right-6 w-48 bg-white p-2 rounded-lg shadow-lg z-50 opacity-container" style="margin-top: 2.8rem;">
                <span class="block text-sm mb-0">Opacity: {Math.round(slay.opacity * 100)}%</span>
                <input 
                    type="range" 
                    min="0" 
                    max="100" 
                    value={slay.opacity * 100}
                    class="w-full"
                    on:input={(e) => handleOpacityChange(slay, e)}
                />
            </div>
          {/if}

          <!-- Legend section -->
          {#if slay.legendVisible && slay.legendData}
              <div class="mt-0 p-2 bg-white border rounded-lg transform transition-all duration-300 ease-in-out 
                  opacity-100 scale-y-100 origin-top"
                  in:slide={{ duration: 300, easing: quintOut }}
                  out:slide={{ duration: 300, easing: quintOut }}>
                  {#each slay.legendData as item}
                      <div class="flex items-center mb-2">
                          {#if item.imageData}
                              <img src={item.imageData} alt={item.label} class="mr-2" />
                          {:else if item.imageUrl}
                              <img src={item.imageUrl} alt={item.label} class="mr-2" />
                          {/if}
                          <span class="text-xs">{item.label}</span>
                      </div>
                  {/each}
              </div>
          {/if}
        </div>
      {/each}
      </div>
    {/if}
  </div>

  